export default __webpack_public_path__ + "static/media/logo-tagline-white.db1395f0.svg";